import { css } from "@emotion/react";
import { color } from "@/styles/theme";

type Props = {
  children: React.ReactNode;
  isDisableArrow?: boolean;
  arrowDirection?: "top" | "bottom";
  className?: string;
};

export const BubbleMark = (props: Props) => {
  const { isDisableArrow = false, arrowDirection = "bottom" } = props;
  return (
    <div
      css={[container, !isDisableArrow && getArrowStyle(arrowDirection)]}
      className={props.className}
    >
      <div>{props.children}</div>
    </div>
  );
};

const getArrowStyle = (arrowDirection: "top" | "bottom") => {
  const arrowDirectionsOverlay = {
    top: {
      borderBottom: `11px solid ${color.primary}`,
      borderLeft: `9px solid transparent`,
      borderRight: `9px solid transparent`,
      top: 0,
      left: "50%",
      transform: "translate(-50%, -100%)",
    },
    bottom: {
      borderTop: `11px solid ${color.primary}`,
      borderRight: `9px solid transparent`,
      borderLeft: `9px solid transparent`,
      bottom: 0,
      left: "50%",
      transform: "translate(-50%, 100%)",
    },
  };

  const arrows = {
    top: css(arrowBase, {
      "&:after": {
        ...arrowDirectionsOverlay.top,
        top: 0,
      },
    }),
    bottom: css(arrowBase, {
      "&:after": {
        ...arrowDirectionsOverlay.bottom,
      },
    }),
  };

  return arrows[arrowDirection];
};

const container = css({
  color: color.white,
  padding: 10,
  backgroundColor: color.primary,
  border: `1px solid ${color.primary}`,
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  height: "100%",
});

// 吹き出しの矢印のベース
const arrowBase = css({
  "&:after": {
    content: '""',
    position: "absolute",
  },
});
